import Checkbox from "@/Components/Checkbox/Checkbox";
import DraggableRow from "@/Components/DraggableRow/DraggableRow";
import { reorder } from "@/shared/utils/helpers";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const Languages = () => {
  const { t } = useTranslation("", { keyPrefix: "settings_page" });
  const { control } = useFormContext();

  return (
    <Controller
      name="languages"
      control={control}
      render={({ value: languages, onChange }) => (
        <DraggableRow
          label={t("languages")}
          hint={t("cards.languagesHint")}
          variant="card"
          droppableId="draggableLanguageslId"
          onDrageEnd={({ destination, source }) => {
            if (!destination) {
              return;
            }
            onChange(reorder(languages, source.index, destination.index));
          }}
          list={languages.map((item) => ({
            key: item.value.toString(),
            component: (
              <>
                <div className="mr-[2rem]">
                  <Checkbox
                    checked={item.isActive}
                    active={item.isActive}
                    name={item.label}
                    onChange={(e) => {
                      const newData = languages.map((item) => {
                        if (item.label === e.target.name) {
                          return {
                            ...item,
                            isActive: e.target.checked,
                          };
                        } else {
                          return { ...item };
                        }
                      });
                      if (newData.some((data) => data.isActive)) {
                        onChange(newData);
                      } else {
                        toast.error(t("minimalOneLanguageIsRequired"));
                      }
                    }}
                  />
                </div>
                <div>{t(item.label)}</div>
              </>
            ),
          }))}
        />
      )}
    />
  );
};

export default Languages;
